import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import LandingPage from './Components/Landing/LandingPage';
import ClientLogin from './Components/Auth/ClientLogin';
import AddUser from './Components/User/AddUser';
import ManageUsers from './Components/User/ManageUser';
import ManageDevice from './Components/Device/ManageDevice';
import ControlPanel from './Components/Device/ControlPanel';
import ForgotPassword from './Components/Auth/ForgotPassword';
import Layout from './Components/Layout';
import WaterLevelSensorHistory from './Components/Device/WaterLevelSensor/WaterLevelSensorHistory';
import WaterLevelErrorHistory from './Components/Device/WaterLevelSensor/WaterLevelErrorHistory';
import ResetPassword from './Components/Auth/ResetPassword';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

// This wrapper component will check for a token and navigate appropriately based on user type
const PublicRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  if (!token) return children;

  try {
    const decoded = jwtDecode(token);
    return <Navigate to="/manage-device" replace />;
  } catch (error) {
    console.error('Invalid token:', error);
    return children;
  }
};

// Protected Route component that handles role-based access
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  if (!token) return <Navigate to="/client-login" replace />;

  try {
    const decoded = jwtDecode(token);
    return children;
  } catch (error) {
    console.error('Invalid token:', error);
    return <Navigate to="/client-login" replace />;
  }
};

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          {/* Landing Page */}
          <Route path="/" element={
            <PublicRoute>
              <LandingPage />
            </PublicRoute>
          } />
          
          {/* Public Routes */}
          <Route path="/client-login" element={
            <PublicRoute>
              <ClientLogin />
            </PublicRoute>
          } />
          <Route path="/forgot-password" element={
            <PublicRoute>
              <ForgotPassword />
            </PublicRoute>
          } />
          <Route path="/reset-password" element={
            <PublicRoute>
              <ResetPassword />
            </PublicRoute>
          } />
          
          {/* Protected Routes - Dashboard/Logic Area */}
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <ManageDevice />
            </ProtectedRoute>
          } />
          <Route path="/manage-device" element={
            <ProtectedRoute>
              <ManageDevice />
            </ProtectedRoute>
          } />
          <Route path="/add-user" element={
            <ProtectedRoute>
              <AddUser />
            </ProtectedRoute>
          } />
          <Route path="/manage-user" element={
            <ProtectedRoute>
              <ManageUsers />
            </ProtectedRoute>
          } />
          <Route path="/control-panel/:deviceId" element={
            <ProtectedRoute>
              <ControlPanel />
            </ProtectedRoute>
          } />
          <Route path="/historygraph/waterlevelsensor/:deviceCode/:sensorSubId" element={
            <ProtectedRoute>
              <WaterLevelSensorHistory />
            </ProtectedRoute>
          } />
          <Route path="/device/error-history/:deviceId" element={
            <ProtectedRoute>
              <WaterLevelErrorHistory />
            </ProtectedRoute>
          } />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
